import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../../../../context/LanguageContext';
import Navbar from '../../../components/navbar/ui/Navbar';
import Footer from '../../../components/footer/ui/Footer';
import ScrollToTop from '../../../components/scroll-to-top/ui/ScrollToTop';
import ProductDetailsSection from '../components/ui/ProductDetailsSection';
import translations from '../../../../assets/features/Translations';
import { initializeProductDetails } from '../components/script/product-details-logic';
import SEO from '../../../components/seo/SEO';

const ProductDetailsPage: React.FC = () => {
    const { language } = useLanguage();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        // Expose language context to window for product details script
        (window as any).LanguageContext = {
            getCurrentLanguage: () => language
        };
        
        // Expose translations to window for product details script
        (window as any).translations = translations;

        // Clear cached product data when ID changes
        if (id && (window as any).currentProductData) {
            delete (window as any).currentProductData;
        }

        // Load CategoryEnum first (only if not already loaded)
        const loadCategoryEnum = async () => {
            if (!(window as any).categoryEnum) {
                const existingCategoryScript = document.querySelector('script[src="/data/enum/CategoryEnum.js"]');
                if (!existingCategoryScript) {
                    await new Promise<void>((resolve) => {
                        const categoryScript = document.createElement('script');
                        categoryScript.src = '/data/enum/CategoryEnum.js';
                        categoryScript.onload = () => {
                            resolve();
                        };
                        categoryScript.onerror = () => {
                            resolve();
                        };
                        document.head.appendChild(categoryScript);
                    });
                }
            }
        };

        // Initialize product details
        loadCategoryEnum().then(() => {
            setTimeout(() => {
                initializeProductDetails();
            }, 100);
        });

        return () => {
            // Don't delete LanguageContext and translations on cleanup
            // They need to persist for the script to work
        };
    }, [id, language]); // Run when product ID or language changes

    // Scroll to top when product ID changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    return (
        <div className="product-details-page">
            <SEO
                title={`Produto — Roady Centro-Auto Paços de Ferreira`}
                description="Detalhes do produto. Loja Roady Centro-Auto Paços de Ferreira."
                noindex={true}
            />
            <Navbar />
            <ProductDetailsSection key={id} />
            <Footer />
            <ScrollToTop />
        </div>
    );
};

export default ProductDetailsPage;

